import { faFilter } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu } from '@nexelem/components';
import { useTableTranslation } from '../translations';

type AdvancedFiltersButtonProps = {
  onClick: () => void;
};

export const AdvancedFiltersButton = ({ onClick }: AdvancedFiltersButtonProps) => {
  const { t } = useTableTranslation();
  return (
    <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faFilter} />} onClick={onClick}>
      {t('advancedFilters')}
    </DropdownMenu.Button>
  );
};
